enum VendorNameOverrideEnum {
    NULL = "null",
    VENDOR = "vendor",
    RETAILER = "retailer",
    CUSTOMER = "customer",
    DEALER = "dealer",
    RESELLER = "reseller",
}

export default VendorNameOverrideEnum;
